import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../auth/AuthContext";

export default function RequireAuth() {
  const { user, setUser } = useAuth();
  const location = useLocation();
  const [state, setState] = useState(user || location.state?.user ? "authed" : "checking");

  useEffect(() => {
    if (location.state?.user) {
      setUser(location.state.user);
      setState("authed");
      return;
    }
    if (user) {
      setState("authed");
      return;
    }
    let active = true;
    api
      .get("/auth/me")
      .then((r) => {
        if (active) {
          setUser(r.data);
          setState("authed");
        }
      })
      .catch(() => active && setState("guest"));
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (state === "checking") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#08080A]" data-testid="auth-checking">
        <span className="h-6 w-6 animate-spin rounded-full border-2 border-[#D4AF37]/30 border-t-[#D4AF37]" />
      </div>
    );
  }
  if (state === "guest") return <Navigate to="/login" replace />;
  return <Outlet />;
}
